/**
 * Returns folder map
 * @param {Object} state the redux store
 * @return {Object} id -> folder
 */
export const getFolders = state => state.entities.folders.entities;
